import { render } from "./PdfExtraction.vue?vue&type=template&id=6f00488c&scoped=true"
import script from "./PdfExtraction.vue?vue&type=script&lang=js"
export * from "./PdfExtraction.vue?vue&type=script&lang=js"

import "./PdfExtraction.vue?vue&type=style&index=0&id=6f00488c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f00488c"]])

export default __exports__